import { Button, Icon } from '@repo/ui';

function ArReportingReload({ isLoading, refetch }: { isLoading: boolean; refetch: () => void }) {
  return (
    <Button
      variant="outline"
      loading={isLoading}
      disabled={isLoading}
      onClick={() => refetch()}
      className="text-sm font-light min-h-[2.375rem] border border-xtnd-light dark:border-xtnd-dark rounded-md px-2 py-1"
      size="sm"
      leftIcon={<Icon name="FiRefreshCw" size="sm" />}
    >
      Reload
    </Button>
  );
}

export default ArReportingReload;
